import { useNavigate } from "react-router-dom";
import { useDeleteUser, useGetUser } from "../../features/user";
import { FiEye, FiPenTool, FiTrash } from "react-icons/fi";
import ModalConfirmationDelete from "../../components/ModalConfirmationDelete";
import { useState } from "react";
import { FaPen, FaPenAlt } from "react-icons/fa";

const UserPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [id, setId] = useState("");
  const { user, isLoading } = useGetUser();
  const navigate = useNavigate();
  const { Delete } = useDeleteUser();
  const router = useNavigate();
  if (isLoading) return null;

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirmDelete = () => {
    Delete(id);
    setIsModalOpen(false);
  };
  return (
    <>
      <div className="p-6">
        <div className="overflow-x-auto">
          <div className="flex justify-between mb-5">
            <h1 className="mt-2 mb-5 font-semibold text-xl text-gray-900">
              User List
            </h1>
            <button
              type="button"
              onClick={() => navigate("/user/create")} // Navigate to user listing or another page
              className=" mt-6 text-xs px-3 bg-green-500 text-white font-medium rounded-md focus:outline-none focus:ring-2"
            >
              Create
            </button>
          </div>
          <table className="min-w-full bg-white rounded-lg shadow-md">
            <thead className="bg-blue-800 text-white">
              <tr>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Username
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Phone
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Role
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {user?.map((order, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {order?.name}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {order?.username}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {order?.phone ?? "-"}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {order?.role}
                  </td>
                  <td className="px-6 py-4 cursor-pointer text-sm text-gray-700 flex gap-3 items-center">
                    <div onClick={() => router(`/user/edit/${order?.id}`)}>
                      <FaPenAlt />
                    </div>
                    <div
                      onClick={() => {
                        setIsModalOpen(true);
                        setId(order?.id);
                      }}
                    >
                      <FiTrash />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <ModalConfirmationDelete
        isOpen={isModalOpen}
        title="Apakah Anda yakin akan Delete User"
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
      />
    </>
  );
};

export default UserPage;
